import { Anchor, Group, Stack, Text, ThemeIcon, Title } from '@mantine/core';
import { IconArrowLeft } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useLanguageAwareRouting } from '@/hooks/useLanguageAwareRouting';
import { getIntegrationBySlug } from './data';

interface IntegrationDetailProps {
  slug: string;
}

export function IntegrationDetail({ slug }: IntegrationDetailProps) {
  const { t } = useTranslation();
  const { createLanguageURL } = useLanguageAwareRouting();
  const integration = getIntegrationBySlug(slug);

  if (!integration) {
    return (
      <Stack gap="md">
        <Anchor
          component={Link}
          to={createLanguageURL('/integrations')}
          size="sm"
          style={{ display: 'inline-flex', alignItems: 'center', gap: 4 }}
        >
          <IconArrowLeft size={14} />
          {t('integrations.cards.backToList')}
        </Anchor>
        <Title order={1}>{t('integrations.cards.notFound')}</Title>
        <Text c="dimmed">{t('integrations.cards.notFoundDescription')}</Text>
      </Stack>
    );
  }

  const Icon = integration.icon;

  return (
    <Stack gap="lg">
      <Anchor
        component={Link}
        to={createLanguageURL('/integrations')}
        size="sm"
        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, alignSelf: 'flex-start' }}
      >
        <IconArrowLeft size={14} />
        {t('integrations.cards.backToList')}
      </Anchor>
      <Group gap="md" align="flex-start">
        <ThemeIcon size={56} radius="md" variant="light" color={integration.color}>
          <Icon size={28} />
        </ThemeIcon>
        <Stack gap={4}>
          <Title order={1}>{t(integration.titleKey)}</Title>
          <Text c="dimmed">{t(integration.subtitleKey)}</Text>
        </Stack>
      </Group>
      {integration.renderDetail(t)}
    </Stack>
  );
}
